module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_crystal_small.RU.aaa10536.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_crystal_small.RU.png
// module id = 2999
// module chunks = 11